import React, { useContext, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, FormControl, FormHelperText, TextareaAutosize, DialogActions, Button } from '@material-ui/core';
import { LangCtx } from '../../../../lib/context';
import { validateCharecters, validateConfigCode } from '../../../../lib/validation';
import { createDepartment, updateDepartment } from '../../../../actions/configuration';
import { toast } from 'react-toastify';
import Loader from '../../../../lib/ui/loader/Loader';
import InputField from '../../../../lib/ui/inputs/Input';

const CreateDepartment = ({ open, handleClose, deptData, loadData }) =>
{

    const { l } = useContext(LangCtx);
    const [ depData, setDepData ] = useState({
        deptName: deptData?.name ? deptData?.name : '',
        code: deptData?.code ? deptData?.code : '',
        desc: deptData?.description ? deptData?.description : ''
    });

    const [ formError, setFormError ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const handleChange = (e) =>
    {
        e.persist();
        const id = e.target.id || e.target.name;
        setDepData((prevState) => ({
            ...prevState,
            [ id ]: e.target.value
        }));
    };

    const handleSave = (e) =>
    {
        e.preventDefault();
        const { deptName, code, desc } = depData;
        let form_error = {};

        if (deptName === '')
        {
            form_error[ 'deptName' ] = l.pls_enter_name;
        } else if (deptName !== '' && !validateCharecters(deptName))
        {
            form_error[ 'deptName' ] = l.pls_enter_valid_name;
        }

        if (code !== '' && !validateConfigCode(code))
        {
            form_error[ 'code' ] = l.pls_enter_valid_code;
        }

        // if(desc !== '' && validateConfigDesc(desc)){
        //     form_error['desc'] = 'Please Enter Valid Description'
        // }

        console.log('fomr error', form_error);
        setFormError(form_error);

        if (Object.keys(form_error).length <= 0)
        {
            if (!loading)
            {
                let body = {
                    name: deptName,
                    code: code,
                    description: desc
                };

                if (deptData)
                {
                    body[ 'id' ] = deptData?._id;
                    setLoading(true);
                    updateDepartment(body).then((res) =>
                    {
                        if (res.status)
                        {
                            toast.success(l.dep_updated, {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            handleClose(true);
                        } else
                        {
                            console.log('something went wrong');
                        }

                        setLoading(false);
                    }).catch((err) =>
                    {
                        toast.error(err?.response?.data?.error, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setLoading(false);
                    });
                } else
                {
                    setLoading(true);
                    createDepartment(body).then((res) =>
                    {
                        if (res.status)
                        {
                            toast.success(l.dep_Creted, {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            handleClose(true);
                        } else
                        {
                            console.log('something went wrong');
                        }
                        setLoading(false);
                    }).catch((err) =>
                    {
                        toast.error(err?.response?.data?.error, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                        setLoading(false);
                    });
                }
            }
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth='sm'>
            {loading && <Loader />}
            <DialogTitle id="form-dialog-title">{deptData ? l.edit_department : l.create_department}</DialogTitle>
            <DialogContent>
                <div className='flexCol'>
                    <small className="inpLabel">{l.department_name}<span className="redTxt">*</span>:</small>
                    <div className="inputRowFeild">
                        <FormControl fullWidth>
                            <InputField
                                placeholder=""
                                type="text"
                                id='deptName'
                                name='deptName'
                                maxLength="30"
                                value={depData?.deptName}
                                error={formError && formError?.deptName}
                                errorMsg={formError?.deptName}
                                onChange={handleChange}
                            />
                            {/* {formError['deptName'] &&
                                        <FormHelperText id="component-error-text" className='redTxt'>{}</FormHelperText>
                                    } */}
                        </FormControl>
                    </div>
                </div>
                <small className="inpLabel">{l.departmant_code}</small>
                <div className="inputRowFeild">
                    <FormControl fullWidth>
                        <InputField
                            placeholder=""
                            type="text"
                            id='code'
                            name='code'
                            value={depData?.code}
                            error={formError && formError?.code}
                            errorMsg={formError?.code}
                            maxLength={6}
                            onChange={handleChange}
                        />
                        <FormHelperText id="component-error-text" className='redTxt'>{formError?.code}</FormHelperText>
                    </FormControl>
                </div>
                <div className='flexCol'>
                    <small className="inpLabel">{l.desc}</small>
                    <div className="inputRowFeild">
                        <FormControl fullWidth>
                            <TextareaAutosize aria-label="empty textarea" minRows={5} placeholder={l.add_description} id='desc' maxLength={150} name='desc' value={depData?.desc} onChange={handleChange} />
                            <FormHelperText id="component-error-text" className='redTxt'>{formError?.desc}</FormHelperText>
                        </FormControl>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {l.cancel}
                </Button>
                <Button variant="contained" color="primary" href="#contained-buttons" className='whiteTxt' onClick={handleSave}>
                    {deptData ? l.update : l.add}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateDepartment;